import _ from 'lodash';

export class PollingManager {
  constructor(client) {
    this.client = client;
    this._timers = new Map();
    this._configs = new Map();
  }

  startPolling(intervalMs = 3000) {
    this.client._queries.forEach((queryInfo, key) => {
      if (!this._timers.has(key)) {
        this.startPollingForKey(key, queryInfo, intervalMs);
      }
    });
    return this;
  }

  startPollingForKey(key, queryInfo, intervalMs = 3000) {
    if (this._timers.has(key)) return this;

    const timer = setInterval(async () => {
      try {
        await this.client.query(queryInfo.builder).exec();
      } catch (error) {
        if (_.get(this._configs.get(key), 'stopOnError')) {
          this.stopPollingForKey(key);
        }
      }
    }, intervalMs);

    this._timers.set(key, timer);
    this._configs.set(key, { intervalMs });
    return this;
  }

  stopPolling(conditionFn) {
    if (!_.isFunction(conditionFn)) throw new Error('Condition must be a function');
    
    this._timers.forEach((timer, key) => {
      const currentData = this.client.store.get(key);
      if (conditionFn(currentData)) {
        this.stopPollingForKey(key);
      }
    });
    return this;
  }

  stopPollingForKey(key) {
    const timer = this._timers.get(key);
    if (timer) {
      clearInterval(timer);
      this._timers.delete(key);
      this._configs.delete(key);
    }
    return this;
  }

  stopAllPolling() {
    this._timers.forEach((timer, key) => this.stopPollingForKey(key));
    return this;
  }

  configurePolling(key, options = {}) {
    this._configs.set(key, { stopOnError: false, maxRetries: 3, ...options });
    return this;
  }

  getPollingStatus() {
    return _(this._timers)
      .mapValues((timer, key) => ({
        active: true,
        interval: _.get(this._configs.get(key), 'intervalMs', 'unknown'),
        timer: !!timer
      }))
      .value();
  }

  pausePolling(key) {
    const timer = this._timers.get(key);
    if (timer) {
      clearInterval(timer);
      this._timers.delete(key);
    }
    return this;
  }

  resumePolling(key) {
    const config = this._configs.get(key);
    const queryInfo = this.client._queries.get(key);
    
    if (config && queryInfo && !this._timers.has(key)) {
      this.startPollingForKey(key, queryInfo, config.intervalMs);
    }
    return this;
  }

  updateInterval(key, newIntervalMs) {
    if (this._timers.has(key)) {
      this.pausePolling(key);
      const config = this._configs.get(key);
      this._configs.set(key, { ...config, intervalMs: newIntervalMs });
      this.resumePolling(key);
    }
    return this;
  }

  cleanup() {
    this.stopAllPolling();
    this._configs.clear();
    return this;
  }
}



// WEBPACK FOOTER //
// ./src/app/lib/directus-sdk/polling.js